import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';
import { AllCountriesQuery } from '../gql/graphql';

const allCountries = graphql(/* GraphQL */ `
  query allCountries {
    countries {
      countryId
      countryName
    }
  }
`);

const useGetCountries = () => {
  const { data, isLoading } = useQuery<AllCountriesQuery>({
    queryKey: ['countries'],
    queryFn: async () => graphqlRequest<AllCountriesQuery>(allCountries), // Public endpoint, no auth needed
    staleTime: 3600000,
    retry: shouldRetryQuery,
  });

  return {
    countries: data,
    countryLoading: isLoading,
  };
};

export default useGetCountries;
